import { CategoryNavigation } from "../components/category-navigation/CategoryNavigation";

const test = ({
  __typename,
  name,
}: {
  __typename: string;
  name: string;
}): boolean =>
  __typename === "VinoData_Navigation" &&
  name.includes(`Category Navigation (${process.env.GATSBY_VM_MARKET})`);

const create = ({ items }): JSX.Element => {
  return <CategoryNavigation navigationItems={items} />;
};

export default { test, create };
